import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/program_document`;

export const ACTION_TYPES = {
  FETCH_PROGRAMDOCUMENTS_LIST: 'PROGRAMDOCUMENTS/FETCH_PROGRAMDOCUMENTS_LIST',
  FETCH_PROGRAMDOCUMENTS: 'PROGRAMDOCUMENTS/FETCH_PROGRAMDOCUMENTS',
  CREATE_PROGRAMDOCUMENTS: 'PROGRAMDOCUMENTS/CREATE_PROGRAMDOCUMENTS',
  UPDATE_PROGRAMDOCUMENTS: 'PROGRAMDOCUMENTS/UPDATE_PROGRAMDOCUMENTS',
  DELETE_PROGRAMDOCUMENTS: 'PROGRAMDOCUMENTS/DELETE_PROGRAMDOCUMENTS',
  RESET: 'PROGRAMDOCUMENTS/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
};

// REDUCER
const programdocumentReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PROGRAMDOCUMENTS):
    case REQUEST(ACTION_TYPES.UPDATE_PROGRAMDOCUMENTS):
    case REQUEST(ACTION_TYPES.DELETE_PROGRAMDOCUMENTS):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS):
    case FAILURE(ACTION_TYPES.CREATE_PROGRAMDOCUMENTS):
    case FAILURE(ACTION_TYPES.UPDATE_PROGRAMDOCUMENTS):
    case FAILURE(ACTION_TYPES.DELETE_PROGRAMDOCUMENTS):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMDOCUMENTS):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROGRAMDOCUMENTS):
    case SUCCESS(ACTION_TYPES.UPDATE_PROGRAMDOCUMENTS):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PROGRAMDOCUMENTS):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default programdocumentReducer;

// ACTIONS
export const getEntities = (idProgram, revisionNum) => ({
  type: ACTION_TYPES.FETCH_PROGRAMDOCUMENTS_LIST,
  payload: axios.get(`${apiUrl}?program_id=${idProgram}&program_revision_num=${revisionNum}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PROGRAMDOCUMENTS,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const deleteEntity = (id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PROGRAMDOCUMENTS,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
